import React from 'react';
import { AlertTriangle, ShieldAlert, TrendingDown, Activity, Calendar } from 'lucide-react';
import { Badge } from '@/components/ui/badge';
import type { AlertaPreditivo } from '@/hooks/useEmpAlertasPreditivos';

interface Props {
  alertas: AlertaPreditivo[];
}

const iconMap: Record<string, React.ReactNode> = {
  PRED_001: <AlertTriangle className="h-4 w-4 text-warning shrink-0" />,
  PRED_002: <ShieldAlert className="h-4 w-4 text-destructive shrink-0" />,
  PRED_003: <TrendingDown className="h-4 w-4 text-destructive shrink-0" />,
  PRED_004: <Activity className="h-4 w-4 text-warning shrink-0" />,
  PRED_005: <Calendar className="h-4 w-4 text-destructive shrink-0" />,
};

const sevVariant = (s: string): 'default' | 'secondary' | 'destructive' | 'outline' => {
  if (s === 'critico') return 'destructive';
  if (s === 'alto') return 'destructive';
  if (s === 'medio') return 'secondary';
  return 'outline';
};

const sevBorder = (s: string) => {
  if (s === 'critico') return 'border-l-destructive';
  if (s === 'alto') return 'border-l-destructive/70';
  if (s === 'medio') return 'border-l-warning';
  return 'border-l-muted-foreground';
};

export const PredictiveAlertsBanner: React.FC<Props> = ({ alertas }) => {
  if (alertas.length === 0) return null;

  return (
    <div className="space-y-2">
      <div className="flex items-center gap-2 text-sm font-medium text-foreground">
        <ShieldAlert className="h-4 w-4 text-primary" />
        <span>Alertas Preditivos</span>
        <Badge variant="secondary" className="text-xs">{alertas.length}</Badge>
      </div>
      <div className="space-y-1.5">
        {alertas.map((a) => (
          <div
            key={a.id}
            className={`flex items-start gap-3 p-3 rounded-lg border border-l-4 ${sevBorder(a.severidade)} bg-card`}
          >
            {iconMap[a.codigo] ?? <AlertTriangle className="h-4 w-4 text-muted-foreground shrink-0" />}
            <div className="flex-1 min-w-0">
              <div className="flex items-center gap-2 mb-0.5">
                <span className="text-sm font-medium text-foreground">{a.titulo}</span>
                <Badge variant={sevVariant(a.severidade)} className="text-xs px-1.5 py-0">
                  {a.severidade}
                </Badge>
              </div>
              {a.descricao && (
                <p className="text-xs text-muted-foreground leading-relaxed">{a.descricao}</p>
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};
